import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProductService } from '../services';
import { Product } from '../interfaces';
import { Observable } from 'rxjs';

export const productResolver: ResolveFn<Product> = (route, state): Observable<Product> => {
  const service = inject(ProductService);
  return service.get(route.paramMap.get('id') as string, { fields: { produits: 'id,id_old,marque,reference,modification_ebay_a_verifier,colonnes_modifies,modification_ebay_par,modification_ebay_le' } })
};
